import React from "react"
import PromoFormAdmin from "../../components/AdminComponents/PromoFormAdmin"

const CreateCode = (props) => {
  return (
    <React.Fragment>
        <PromoFormAdmin props={props}/>
    </React.Fragment>
  )
}

export default CreateCode;
